import IconActionButton from "./IconActionButton";
import BiotechOutlinedIcon from "@mui/icons-material/BiotechOutlined";

const DonorDiagnosticIconButton = ({title, disabled = false, onClick}) => (
    <IconActionButton
        disabled={disabled}
        title={title}
        onClick={onClick}
        className="text-teal-700 ml-3"
    >
        <BiotechOutlinedIcon fontSize="small"/>
    </IconActionButton>
);

export default DonorDiagnosticIconButton;
